import { Box, useTheme } from "@mui/material";
import Header from "../../components/Header";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { tokens } from "../../theme";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import HomeTopBar from "../../components/HomeTopBar";


const Pricing = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const navigate = useNavigate();
  

  return (
    <>
    <HomeTopBar />
    <Box m="20px" padding={"6rem"}>
      <Header title="Pricing" subtitle="Prices for every business type" />

      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography color={colors.greenAccent[500]} variant="h5">
            Less than 3 Users and 500 Customers?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Free. No Credit Card Required.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography color={colors.greenAccent[500]} variant="h5">
            3-5 Users and 500-1,000 Customers?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            First month free. Then $19.99 per month after. Cancel anytime.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography color={colors.greenAccent[500]} variant="h5">
            6-10 Users and 1,000-10,000 Customers?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            First month free. Then $49.99 per month after. Cancel anytime.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography color={colors.greenAccent[500]} variant="h5">
            10+ Users and 10,000+ Customers?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Contact Sales Here.
          </Typography>
        </AccordionDetails>
      </Accordion>
      {/* <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography color={colors.greenAccent[500]} variant="h5">
            The Final Question
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            malesuada lacus ex, sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
      </Accordion> */}
    </Box>
    </>
  );
};

export default Pricing;
